import { cloneElement, isValidElement, type ReactElement, type ReactNode } from "react";

/** Spell plain-text React children. Attributes (href, className, to) are left alone. */
export function spellReactNode(node: ReactNode, s: (text: string) => string): ReactNode {
  if (node == null || typeof node === "boolean") return node;
  if (typeof node === "string") return s(node);
  if (typeof node === "number") return node;
  if (Array.isArray(node)) return node.map((child) => spellReactNode(child, s));
  if (!isValidElement(node)) return node;

  const element = node as ReactElement<{ children?: ReactNode }>;
  if (typeof element.props.children === "function") return element;
  if (element.props.children == null) return element;
  return cloneElement(element, undefined, spellReactNode(element.props.children, s));
}
